import React from 'react'

const BlogTags = () => {
    return (
        <>
         <div className="w-full">
             <div className=" bg-red- mx-auto">
                    <div className="inline-block bg-red-600 py-1.5 px-2.5 my-1.5 cursor-pointer uppercase text-white text-xs tracking-wider mr-3">
                        fashion
                    </div>
                    <div className="inline-block bg-black py-1.5 px-2.5 cursor-pointer uppercase text-white text-xs tracking-wider mr-3">
                        vouge
                    </div>
                    <div className="inline-block bg-yellow-600 py-1.5 px-2.5 cursor-pointer uppercase text-white text-xs tracking-wider mr-3">
                        gadgets
                    </div>
                    <div className="inline-block bg-purple-600 py-1.5 px-2.5 cursor-pointer uppercase text-white text-xs tracking-wider mr-3">
                        features
                    </div>
             </div>
             </div>   
        </>
    )
}

export default BlogTags
